export default __webpack_public_path__ + "static/media/changepassword.02533d2c.png";